"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocalStorage = void 0;
var react_1 = require("react");
function getInitialValue(storeKey, key, initialValue, preferInitialValue) {
    try {
        var item = window.localStorage.getItem(storeKey);
        if (item === null) {
            return initialValue;
        }
        var store = JSON.parse(item);
        if (preferInitialValue) {
            return initialValue;
        }
        return store[key] ? store[key] : initialValue;
    }
    catch (error) {
        return initialValue;
    }
}
// Hook
function useLocalStorage(storeKey, key, initialValue, ssrHydration) {
    if (ssrHydration === void 0) { ssrHydration = false; }
    var _a = (0, react_1.useState)(function () {
        return getInitialValue(storeKey, key, initialValue, ssrHydration);
    }), storedValue = _a[0], setStoredValue = _a[1];
    (0, react_1.useEffect)(function () {
        if (ssrHydration) {
            setValue(getInitialValue(storeKey, key, initialValue, false));
        }
    }, [ssrHydration]);
    var setValue = function (value) {
        try {
            var valueToStore = value instanceof Function ? value(storedValue) : value;
            var item = window.localStorage.getItem(storeKey);
            var store = item ? JSON.parse(item) : {};
            store[key] = valueToStore;
            setStoredValue(value);
            window.localStorage.setItem(storeKey, JSON.stringify(store));
        }
        catch (error) {
            console.log(error);
        }
    };
    return [storedValue, setValue];
}
exports.useLocalStorage = useLocalStorage;
